import * as S from './styles'
import ImgCarrinho from '../../assets/products/carrinho.png'
import { Link } from 'react-router-dom'
import { ButtonAddNewAddress } from '../../styles/page-profile'

const ErrorNotFound = () => {
  return (
    <S.ErrorBox>
      <img src={ImgCarrinho} alt="" />
      <div className="error-info">
        <h1>404</h1>
        <strong>Ops, página não encontrada</strong>
        <p>
          Verifique o endereço ou utilize a barra
          <br />
          de pesquisa, milhares de ofertas esperam por você
        </p>
        <Link to="/">
          <S.Button>Ir para página Inicial</S.Button>
        </Link>
      </div>
    </S.ErrorBox>
  )
}

export default ErrorNotFound
